import { createFileRoute } from "@tanstack/react-router"
import { DemographicsForm } from "~/components/demographics/DemographicsForm"

export const Route = createFileRoute("/demographics")({
  component: DemographicsPage,
})

function DemographicsPage() {
  return <DemographicsForm />
}
